///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/components/presenters/financeComponent/defaults"/>
export function get() {
    return {
        template: "presenters-finance-component-default",
        options: { dataQa: "amount-value-component" },
        resolution: 2
    };
}